export const baseTheme = {
  colors: {
    body: '#f0f2f5',
    global: '#001489',
    primary: '#EB7514',
    primaryDark: '#001060',
    inverted: '#ffffff',
    light: '#EEEEEE',
    muted: '#5F6B78',
    mutedInverted: 'rgba(255,255,255,0.5)',
    green: '#0AB500',
    dark: '#000329',
    line: '#DCE2EC',
    lineInverted: 'rgba(255,255,255,0.15)',
    red: '#C91900'
  },
  fonts: {
    primary: "'Arial', sans-serif"
  },
  sizes: {
    topBar: '64px',
    gridGap: '1rem'
  }
}
